import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import I18n from '../../resources/i18n/I18n'
import EventApi, { DEFAULT_SIZE } from '../../services/eventApi'
import GroupApi from '../../services/groupApi'
import NotificationApi from '../../services/notificationApi'
import { errorToast, successToast } from '../../utils/toast'
import ActionBar from '../consult/ActionBar'
import Event from '../event/Event'
import Filters from '../filters/Filters'
import Loader from '../loader/Loader'
import Logo from '../logo/Logo'
import Pagination from '../pagination/Pagination'
import Title from '../typo/Title'
import CONSTANTS from '../../utils/constants'
import './consult.scss'

class Consult extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      currentPage: 0,
      pageCount: undefined,
      totalCount: 0,
      pageSize: DEFAULT_SIZE,
      tooMuchEvents: false,
      eventList: [],
      selectedEvents: [],
      showFilters: false,
      group: null,
      currentUser: this.props.user,
      consultedEvents: [],
    }
  }

  UNSAFE_componentWillMount() {
    if (this.props.location.state && this.props.location.state.page) {
      this.setState({ currentPage: this.props.location.state.page })
    }
    if (this.state.currentUser && this.state.currentUser.group) {
      GroupApi.getGroupByCode(this.state.currentUser.group.code)
        .then((group) => this.setState({ group: group }))
        .catch(() => {
          errorToast(I18n.t('ErrorFetchGroup'))
        })
    }
  }

  componentDidMount() {
    //Récupération intiale des événements
    if (this.state.eventList.length === 0) {
      this.fetchEvents(this.state.currentPage)
    }

    // Récupération des événements déjà consultés
    NotificationApi.getConsultedEvents().then((consulted) => {
      this.setState({ consultedEvents: consulted.rows })
    })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    //Actualisation des résultats au changement de filtres
    if (this.props.filters !== nextProps.filters) {
      this.fetchEvents(this.state.currentPage, nextProps.filters, this.state.pageSize)
    }
  }

  fetchEvents = (page, filters, pageSize = null) => {
    this.setState({ loading: true, selectedEvents: [] })
    //si changement de filtres, on remet sur la première page
    if (filters) {
      page = 0
    }
    EventApi.getEventList(filters ? filters : this.props.filters, page, pageSize ? pageSize : this.state.pageSize)
      .then((eventListResponse) => {
        this.setState({
          eventList: eventListResponse.records,
          pageCount: eventListResponse.metadata.pageCount,
          currentPage: page ? page : 0,
          totalCount: eventListResponse.metadata.totalCount,
        })
      })
      .catch(() => {
        errorToast(I18n.t('ErrorFetchEvents'))
      })
      .finally(() => {
        this.setState((state) => ({ ...state, loading: false }))
      })
  }

  updateSelectedEvents = (e) => {
    this.setState({ tooMuchEvents: false })

    if (e.target.checked) {
      const event = this.state.eventList.find((event) => event.id.toString() === e.target.value)
      this.setState({ selectedEvents: [...this.state.selectedEvents, event] })
    } else {
      this.setState({ selectedEvents: this.state.selectedEvents.filter((event) => event.id.toString() !== e.target.value) })
    }
  }

  selectAllSelectedEvents = (e) => {
    this.setState({ tooMuchEvents: false })

    if (e.target.checked) {
      this.setState({ selectedEvents: [...this.state.eventList] })
    } else {
      this.setState({ selectedEvents: [] })
    }
  }

  toggleFilters = (show) => {
    this.setState({ showFilters: show })
  }

  markAsRead = () => {
    if (this.state.selectedEvents.length > 0) {
      NotificationApi.markAsRead(this.state.selectedEvents.map((e) => e.id)).then((consulted) => {
        this.setState({
          consultedEvents: consulted.rows,
          selectedEvents: [],
        })
      })
    }
  }

  fetchEventsWithPagination = (event) => {
    const pageSize = parseInt(event.target.value, 10)
    this.setState({
      pageSize: pageSize,
    })
    this.fetchEvents(0, this.state.filters, pageSize)
  }

  saveEventsStatus = async () => {
    const FormattedSelectedEventsToUpdate = {
      events: this.state.selectedEvents.map((event) => ({
        ...event,
        status: CONSTANTS.STATUS_LIST.VALIDATED,
      })),
    }
    try {
      const result = await EventApi.updateEventsStatus(FormattedSelectedEventsToUpdate)
      successToast(I18n.t('UpdateEventsToastSuccess', { size: result.results?.length ?? 0 }))
    } catch (err) {
      errorToast(I18n.t('UpdateEventsToastError'))
    } finally {
      this.fetchEvents()
    }
  }

  render() {
    return (
      <div className="container-fluid">
        {this.state.loading ? <Loader displayMessage /> : null}
        <Logo />
        <div className="container">
          <div className="row">
            <Title text={I18n.t('ConsultTitle')} />
            <div className="container d-flex justify-content-end mb-4">
              <ActionBar
                actions={{ export: true }}
                resultsCount={this.state.eventList.length}
                addEvent
                toggleFilters={this.toggleFilters}
                filters={this.props.filters}
                selectedEvents={this.state.selectedEvents || []}
                markAsRead={this.markAsRead}
                userRoles={this.props.user.roles}
                saveEventsStatus={this.saveEventsStatus}
              />
            </div>
          </div>
          <div className="row">
            <div className={'col-md-3 filters ' + (!this.state.showFilters ? 'hidden' : '')}>
              <Filters toggleFilters={this.toggleFilters} />
            </div>
            <div className="col-12 col-md-9 mt-3">
              {this.state.pageCount !== 0 && (
                <div className="d-flex mb-2">
                  <div className="col-md-1 col-1 d-flex align-items-center justify-content-center">
                    <input
                      id="select-all"
                      key="select-all"
                      className="filter-checkbox"
                      type="checkbox"
                      checked={this.state.selectedEvents.length === this.state.eventList.length}
                      onChange={this.selectAllSelectedEvents}
                    />
                    <label htmlFor="select-all" onClick={(e) => e.stopPropagation()} />
                  </div>
                  <label htmlFor="select-all" className="input-subtext-title">
                    {I18n.t('SelectAll')}
                  </label>
                </div>
              )}
              {this.state.pageCount !== 0 ? (
                this.state.eventList.map((event) => {
                  return (
                    <Event
                      key={event.id}
                      event={event}
                      page={this.state.currentPage}
                      group={this.state.group}
                      onExport={this.updateSelectedEvents}
                      exportList={this.state.selectedEvents}
                      isUnread={
                        this.props.user.roles &&
                        (this.props.user.roles.indexOf('ORFI-MANAGER') > -1 || this.props.user.roles.indexOf('ORFI-DIRECTEUR') > -1) &&
                        this.state.consultedEvents.filter((e) => e.idEvent === event.id).length === 0
                      }
                    />
                  )
                })
              ) : (
                <div className="no-result">
                  <span className="icon-warning" />
                  <div>{I18n.t('NoResult')}</div>
                </div>
              )}
              {this.state.eventList.length > 0 && (
                <div className="d-flex justify-content-end">
                  <Pagination
                    onChange={this.fetchEvents}
                    pages={this.state.pageCount}
                    currentPage={this.state.currentPage}
                    totalCount={this.state.totalCount}
                    translationKey="PaginationEvent"
                  />
                  <select className="browser-default custom-select ml-2 w-auto" onChange={this.fetchEventsWithPagination} value={this.state.pageSize}>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    filters: state.searchReducer,
    resources: state.resourceReducer,
    notifications: state.notificationReducer.notifications,
    user: state.userReducer.user,
  }
}

export default connect(mapStateToProps)(withRouter(Consult))
